// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fnqS","colBig":"styles_colBig__1-rXp","colSmall":"styles_colSmall__184JU"};